import React from "react";
import AllPrints from "../Components/AllPrints/AllPrints";

const Prints = () => {
  return (
    <div>
      <AllPrints />
    </div>
  );
};

export default Prints;
